import {
    DEALERGETFEEREPORTLIST_SUCCESS,
    DEALERGETFEEREPORTLIST_FAILED,
    RESET_DEALERGETFEEREPORTLIST,
    LOADING_DEALERGETFEEREPORTLIST,
    NETWORK_ERROR_DEALERGETFEEREPORTLIST
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerGetFeeReportList = () => {
    return { type: RESET_DEALERGETFEEREPORTLIST };
};

const dealerGetFeeReportList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERGETFEEREPORTLIST });
    await dealerServices
        .post("getFeeReportList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetFeeReportListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetFeeReportListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERGETFEEREPORTLIST,
                payload: err
            });
        });
};

function dealerGetFeeReportListsuccess(data) {
    return {
        type: DEALERGETFEEREPORTLIST_SUCCESS,
        payload: data
    };
}
function dealerGetFeeReportListFailed(data) {
    return {
        type: DEALERGETFEEREPORTLIST_FAILED,
        payload: data
    };
}

export { resetDealerGetFeeReportList, dealerGetFeeReportList }